<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Budget Subhead</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/budgetsubheads/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/BudgetSubHeads/MenuList.vue";
    import lang from "@/views/modules/BudgetSubHeads/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/BudgetSubHeads/SearchView.vue";
    export default {
        name: "new-BudgetSubHeads",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [

                    {
                        label: lang.LBL_SUBHEAD_NAME,
                        link: true,
                        moduleName: 'BudgetSubHeads',
                        routePath: 'budgetsubheads',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'name'

                    },
                    {
                        label: lang.LBL_HEAD_NAME,
                        link: false,
                        routePath: 'budgetheads',
                        linkOtherModule: true,
                        isSort: true,
                        relRef:'budgetsubheads_budgetheads',
                        field_name: 'name__budgethead'

                    },
                    {
                        label: lang.LBL_SEQUENCE_NO,
                        link: false,
                        moduleName: 'BudgetSubHeads',
                        routePath: 'budgetsubheads',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'sequence_no'

                    },
                    {
                        label: lang.LBL_IS_CHANGEABLE,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'status'
                    },
                    {
                        label: lang.LBL_STATUS,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'status'
                    },

                ],
                columns: ['name', 'budgethead_name', 'sequence_no', 'is_changeable', 'status'],
            }
        },
        mounted() {
            this.childMethod();
            let user = JSON.parse(localStorage.getItem('user_prefrence'));
            
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>